import {
  CollectionReference,
  DocumentReference,
  Firestore,
  collection as firebaseCollection,
  doc as firebaseDoc,
} from 'firebase/firestore';
import { Observable } from 'rxjs';

export function joinFirestorePath(...pathSegments: string[]): string {
  return pathSegments.join('/');
}

export function castObservable<T>(source: Observable<unknown>): Observable<T> {
  return source as Observable<T>;
}

export function typedCollectionRef<T>(
  firestore: Firestore,
  ...pathSegments: string[]
): CollectionReference<T> {
  return firebaseCollection(
    firestore,
    joinFirestorePath(...pathSegments)
  ) as CollectionReference<T>;
}

export function typedDocRef<T>(
  firestore: Firestore,
  ...pathSegments: string[]
): DocumentReference<T> {
  return firebaseDoc(firestore, joinFirestorePath(...pathSegments)) as DocumentReference<T>;
}
